/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  capacity_assumption: 1600,
  peak_hour_factor: 10,
  lane_repurposing_planned: '',
  roadway_features: [],
  vc: '',
  los: '',
  auto_tier: '',
  land_use_context: '',
  scores: {}
}

const auto = createSlice({
  name: 'auto',
  initialState,
  reducers: {
    setAutoInputs(state, action) {
      const { field, value } = action.payload
      if (field === 'roadway_features') {
        // If filed already includes value remove it / add
        state[field] = state[field].includes(value)
          ? state[field].filter((input) => input !== value)
          : [...state[field], value]
      } else {
        state[field] = value
      }
    },
    setAutoScores(state, action) {
      const { field, value } = action.payload
      state.scores = { ...state.scores, [field]: value }
    },
    resetAutoInputs(state) {
      return initialState
    },
    setAllAutoInputs(state, action) {
      return action.payload
    }
  }
})

export const {
  setAutoInputs,
  setAutoScores,
  resetAutoInputs,
  setAllAutoInputs
} = auto.actions
export default auto.reducer
